export class CartTaxFormValues {
  key: string;
  tax: {};

  constructor(key: string, tax: {}) {
    this.key = key;
    this.tax = tax;
  }
}
